import { motion } from 'framer-motion';
import { useLanguage } from '../../i18n/LanguageContext';

export default function FAQ() {
  const { t } = useLanguage();
  return (
    <section id="faq" className="bg-ev-cream py-24 md:py-32 px-6 md:px-10" data-testid="faq-section">
      <div className="max-w-[1000px] mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display font-light text-ev-ink lowercase text-center mb-12 md:mb-16"
          style={{ fontSize: 'clamp(2rem, 5vw, 4rem)', letterSpacing: '-0.03em' }}>
          {t.faq_h}
        </motion.h2>

        <div className="space-y-3">
          {t.faq_items.map((item, i) => (
            <motion.details
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.04, duration: 0.4 }}
              className="group bg-white rounded-[1.25rem] [&_summary::-webkit-details-marker]:hidden"
              data-testid={`faq-item-${i}`}>
              <summary className="flex items-center justify-between gap-4 p-6 md:p-7 cursor-pointer list-none">
                <h3 className="font-display text-base md:text-lg text-ev-ink leading-snug pr-2">{item.q}</h3>
                <span aria-hidden="true" className="flex-shrink-0 font-display text-2xl text-ev-lime-dim transition-transform duration-300 group-open:rotate-45">+</span>
              </summary>
              <div className="px-6 md:px-7 pb-6 md:pb-7">
                <p className="font-body text-sm md:text-[15px] text-ev-gray leading-relaxed max-w-[800px]">{item.a}</p>
              </div>
            </motion.details>
          ))}
        </div>
      </div>
    </section>
  );
}
